<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
            <pre v-if="arqueo.usuario != null" style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Arqueo Caja</pre>
            <pre v-else style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Arqueo Agencia</pre>
            <table style="border-collapse: collapse; width: 100%; font-size: 26px; text-align: left;">  
                <tr>    
                    <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;"></th>
                    <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000;"></th> 
                </tr> 
                <tr>    
                    <td style="padding: 2px; font-weight:600;">AGENCIA:</td>
                    <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.agencia_seleccionada.nombre}}</td>  
                </tr>   
                <tr>    
                    <td style="padding: 2px; font-weight:600;">FECHA CORTE:</td>
                    <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.fecha_inicio | moment('DD-MM-YYYY HH:mm:ss')}}</td>  
                </tr> 
                <tr>    
                    <td style="padding: 2px; font-weight:600;">CIERRE:</td>
                    <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.fecha_fin | moment('DD-MM-YYYY HH:mm:ss')}}</td>  
                </tr>   
                <tr v-if="arqueo.usuario != null">    
                    <td style="padding: 2px; font-weight:600;">NOMBRE CAJERO/A:</td>
                    <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ arqueo.usuario.name+' '+arqueo.usuario.last_name }}</td>  
                </tr>  
                <tr>    
                    <td style="padding: 2px; font-weight:600;">FECHA Y HORA IMP:</td>
                    <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{arqueo.emitido | moment('DD-MM-YYYY HH:mm')}} HRS</td>  
                </tr>
            </table>
            <span style="border-collapse: collapse; width: 100%; font-size: 22px; padding: 8px; text-align: center;">____________________________________________</span>
            <pre style="margin-top: 20px; padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Venta de Boletos</pre>
            <table style="border-collapse: collapse; width: 100%; font-size: 28px;">
                <tr>    
                    <td style="padding: 2px; font-weight:900; text-align: left;">Tipo de Pago</td>
                    <td style="padding: 2px; font-weight:900; text-align: center;">No de Boletos</td>  
                    <td style="padding: 2px; font-weight:900; text-align: left;">Monto</td>  
                </tr>
                <tr v-if="consulta.boletos_efectivo_mxn.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">EFE (MXN)</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.boletos_efectivo_mxn[0].num_boletos)}}</td>
                    <td style="padding: 2px; font-weight:600; text-align: left;">{{Number(consulta.boletos_efectivo_mxn[0].monto).toFixed(2)}}</td>
                </tr>
                <!--
                <tr v-if="consulta.boletos_efectivo_mxn.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">EFE (DLLS)</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.boletos_efectivo_usd[0].num_boletos)}}</td>
                    <td style="padding: 2px; font-weight:600; text-align: left;">{{Number(consulta.boletos_efectivo_usd_mxn[0].monto).toFixed(2)}} MXN ({{Number(consulta.boletos_efectivo_usd[0].monto).toFixed(2)}} USD)</td>
                </tr>
                -->
                <tr v-if="consulta.boletos_tarjeta.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">TAR</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.boletos_tarjeta[0].num_boletos)}}</td>
                    <td style="padding: 2px; font-weight:600; text-align: left;">{{Number(consulta.boletos_tarjeta[0].monto).toFixed(2)}}</td>
                </tr>
                <!--
                <tr v-if="consulta.boletos_deposito.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">DEP</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.boletos_deposito[0].num_boletos)}}</td>
                    <td style="padding: 2px; font-weight:600; text-align: left;">{{Number(consulta.boletos_deposito[0].monto).toFixed(2)}}</td>
                </tr>
                -->
                <tr>    
                    <td style="padding: 2px; font-weight:900; text-align: left;">TOTAL</td>
                    <td style="padding: 2px; font-weight:900; text-align: center;">{{calculateTotalVentaBoletos}}</td>
                    <td style="padding: 2px; font-weight:900; text-align: left;">{{calculateTotalVentaBoletosMonto}}</td>
                </tr>
            </table>
            
            <span style="border-collapse: collapse; width: 100%; font-size: 22px; padding: 8px; text-align: center;">____________________________________________</span>
            <pre style="margin-top: 20px; padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Movimientos de caja</pre>
            <table style="border-collapse: collapse; width: 100%; font-size: 28px;">
                <tr>    
                    <td style="padding: 2px; font-weight:900; text-align: left; text-transform: uppercase;">+Ingresos</td>
                    <td style="padding: 2px; font-weight:900; text-align: center;">Detalles</td>  
                    <td style="padding: 2px; font-weight:900; text-align: center;">Monto</td>  
                    <td style="padding: 2px; font-weight:900; text-align: center; width: 5%;"></td>  
                </tr>
                <tr v-for="ingreso in consulta.impresion_ingresos_efectivo_mxn" :key="ingreso.id">
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>    
                    <td v-if="ingreso.detalles === ''" style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.motivo}}</td>
                    <td v-else style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.detalles}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center;">{{ingreso.monto}}</td> 
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>  
                </tr>
                <!---
                <tr v-for="ingreso in consulta.impresion_ingresos_efectivo_usd_mxn" :key="ingreso.id">
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>    
                    <td v-if="ingreso.detalles === ''" style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.motivo}}</td>
                    <td v-else style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.detalles}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;">{{ingreso.monto}}</td> 
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>  
                </tr>
                -->
                <tr v-for="ingreso in consulta.impresion_ingresos_tarjeta" :key="ingreso.id">
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>    
                    <td v-if="ingreso.detalles === ''" style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.motivo}}</td>
                    <td v-else style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.detalles}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center;">{{ingreso.monto}}</td> 
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>  
                </tr>
                <!--
                <tr v-for="ingreso in consulta.impresion_ingresos_deposito" :key="ingreso.id">
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>    
                    <td v-if="ingreso.detalles === ''" style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.motivo}}</td>
                    <td v-else style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{ingreso.detalles}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center;">{{ingreso.monto}}</td> 
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>  
                </tr>   
                -->
                <tr>    
                    <td style="padding: 2px; font-weight:900;"></td>
                    <td style="padding: 2px; font-weight:900;">TOTAL INGRESOS</td>
                    <td style="padding: 2px; font-weight:900;">{{calculateTotalMovimientosIngresos}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td> 
                </tr>
            </table>
            <table style="margin-top: 50px; border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">
                <tr>    
                    <td style="padding: 2px; font-weight:900; text-transform: uppercase; font-size: 27px;">-Egresos</td>
                    <td style="padding: 2px; font-weight:900; text-align: center;">Detalles</td>  
                    <td style="padding: 2px; font-weight:900; text-align: center;">Monto</td>  
                    <td style="padding: 2px; font-weight:900; text-align: center; width: 5%;"></td>
                </tr>
                <tr v-for="egreso in consulta.detalle_egresos" :key="egreso.id">
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600;"></td>
                    <td v-if="egreso.detalles === ''" style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{egreso.motivo}}</td>
                    <td v-else style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center; font-size: 21px;">{{egreso.detalles}}</td>
                    <td style="padding:2px; text-transform: uppercase; font-weight: 600; text-align: center;">{{egreso.monto}}</td>  
                    <td style="padding: 2px; font-weight:900;"></td>
                </tr> 
                <tr>    
                    <td style="padding: 2px; font-weight:900;"></td>
                    <td style="padding: 2px; font-weight:900;">TOTAL EGRESOS</td>
                    <td style="padding: 2px; font-weight:900;">{{calculateTotalMovimientosEgresos}}</td>
                    <td style="padding: 2px; font-weight:900;"></td>
                </tr>
            </table>
            
            <span style="border-collapse: collapse; width: 100%; font-size: 22px; padding: 8px; text-align: center;">____________________________________________</span>
            <pre style="margin-top: 20px; padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">General</pre>
            <table style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: center;">
                <tr>    
                    <td style="padding: 2px; font-weight:900; text-align: center;">Tipo de Pago</td>
                    <td style="padding: 2px; font-weight:900; text-align: center;">Monto</td>  
                </tr>
                <tr v-if="consulta.ingresos_efectivo_mxn.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">EFE(MXN)</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.ingresos_efectivo_mxn[0].monto).toFixed(2)}}</td>
                </tr>
                <!---
                <tr v-if="consulta.ingresos_efectivo_usd.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">EFE(DLLS)</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.ingresos_efectivo_usd_mxn[0].monto).toFixed(2)}}</td>
                </tr>
                -->
                <tr v-if="consulta.ingresos_tarjeta.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">TAR</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.ingresos_tarjeta[0].monto).toFixed(2)}}</td>
                </tr>
                <!--
                <tr v-if="consulta.ingresos_deposito.length > 0">    
                    <td style="padding: 2px; font-weight:600; text-align: left;">DEP</td>
                    <td style="padding: 2px; font-weight:600; text-align: center;">{{Number(consulta.ingresos_deposito[0].monto).toFixed(2)}}</td>
                </tr>
                -->
                <tr v-if="consulta.ingresos_efectivo_mxn.length > 0">    
                    <td style="padding: 2px; font-weight:900; font-size: 34px; ">TOTAL EFECTIVO</td>
                    <td style="padding: 2px; font-weight:900;">{{ calculateTotalGeneral }}</td>
                </tr>
            </table>
            <p style="margin-top: 30px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
                {{user.username}}/{{Date.now()  | moment('DDMMYYYY')}}/{{ Date.now()  | moment('HH:mm') }} 
            </p>
        </body>
    </html>
</template>
<script>
export default {
  props: {
    arqueo: {required: false},
    consulta: {required: false},
    user: {required: false},
    tipo: {required: false}
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
  computed: {
    calculateTotalVentaBoletos(){
        var total = 0;
        total = Number(this.consulta.boletos_efectivo_mxn[0].num_boletos) + Number(this.consulta.boletos_tarjeta[0].num_boletos)
        return total;
    },
    calculateTotalVentaBoletosMonto(){
        var total = 0;
        total = Number(this.consulta.boletos_efectivo_mxn[0].monto) + Number(this.consulta.boletos_efectivo_usd_mxn[0].monto) + Number(this.consulta.boletos_tarjeta[0].monto)
        return total.toFixed(2);
    },
    calculateTotalMovimientosIngresos(){
        var total = 0;
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_mxn.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_mxn[i].efectivo_mxn)
        }
        /*
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_usd_mxn.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_usd_mxn[i].efectivo_usd_mxn)
        }
        */  
        for(let i=0; i < this.consulta.impresion_ingresos_tarjeta.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_tarjeta[i].tarjeta)
        }
        return total.toFixed(2);
    },
    calculateTotalMovimientosEgresos(){
        var total = 0;
        for(let i=0; i < this.consulta.detalle_egresos.length; i++){
          total = total + Number(this.consulta.detalle_egresos[i].monto)
        }
        return total.toFixed(2);
    },
    calculateTotalGeneral(){
        var total = 0;
        total = Number(this.consulta.ingresos_efectivo_mxn[0].monto) - this.calculateTotalMovimientosEgresos;
        return total.toFixed(2);
    },
    calculateTotal(){
      var total = 0;
      if(this.tipo === 'Efectivo'){
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_mxn.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_mxn[i].efectivo_mxn)
        }
      }
      if(this.tipo === 'Efectivo USD'){
        for(let i=0; i < this.consulta.impresion_ingresos_efectivo_usd.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_efectivo_usd[i].efectivo_usd)
        }
      }
      if(this.tipo === 'Tarjeta'){
        for(let i=0; i < this.consulta.impresion_ingresos_tarjeta.length; i++){
          total = total + Number(this.consulta.impresion_ingresos_tarjeta[i].tarjeta)
        }
      }
      return total.toFixed(2);
    },
  },
}
</script>